import { render, staticRenderFns } from "./PartSliderHolder.vue?vue&type=template&id=5e2e1218&"
import script from "./PartSliderHolder.vue?vue&type=script&lang=js&"
export * from "./PartSliderHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports